import { configureStore } from "@reduxjs/toolkit";
import shipmentsReducer from "../features/shipments/shipmentsSlice";
import shipmentReducer from "../features/shipment/shipmentSlice";
import shipmentEventsReducer from "../features/shipments/shipmentEvents/shipmentEventsSlice";
import shipmentItemsReducer from "../features/shipment/ShipmentItems/shipmentItemsSlice";
import savedReceiversReducer from "../features/savedReceivers/savedReceiversSlice";
import shipmentBillsReducer from "../features/shipmentBills/shipmentBillsSlice";
import selectCityReducer from "../features/citySelect/selectCitySlice"
import selectProductTypeReducer from "../features/productTypeSelect/productTypeSelectSlice"
import calcReducer from "../features/calc/calcSlice"
import userReducer from "../features/user/userSlice"
import authenticationReducer from "../features/authentication/authSlice"
import registrationReducer from "../features/registration/registrationSlice"

import adminReducer from "../features/admin/adminSlice"

import pathReducer from "../features/path/pathSlice"
import alertReducer from "../features/alerts/alertSlice"

import { getLinkToPaySession } from "../api/getShipmetBillPaymentLink/getShipmentBillLinkToPaySession";



export const store = configureStore({
    reducer: {
        shipments: shipmentsReducer,
        shipment: shipmentReducer,
        shipmentItems: shipmentItemsReducer,
        shipmentEvents: shipmentEventsReducer,
        shipmentBills: shipmentBillsReducer,
        savedReceivers: savedReceiversReducer,
        selectCity: selectCityReducer,
        selectProductType: selectProductTypeReducer,
        calc: calcReducer,
        user: userReducer,
        authentication: authenticationReducer,
        registration: registrationReducer,
        admin: adminReducer,
        path: pathReducer,
        alerts: alertReducer,
        [getLinkToPaySession.reducerPath]: getLinkToPaySession.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(getLinkToPaySession.middleware),
})